import React, { useState } from 'react'
import { Typography, AppBar, Toolbar, List, ListItem, ListItemText, Drawer, useMediaQuery, IconButton, Hidden  } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import { Link as RouterLink } from 'react-router-dom'

import { Menus } from '../constants/config'

function MenuList(props){
    const [open, setOpen] = useState(false);

    return(
        <AppBar position="static">
            <Toolbar>
                <Drawer anchor="left" open={open} onClose={() => {setOpen(false)}}>
                    <div>
                        <List>
                            {Object.keys(Menus).map((key) => (
                                <ListItem button component={RouterLink} key={key} to={key} onClick={() => {setOpen(false)}}>
                                    <ListItemText primary={Menus[key]} />
                                </ListItem>
                            ))}
                        </List>

                    </div>
                </Drawer>
                <Typography align="center" variant="h6">{props.pageName}</Typography>
            </Toolbar>
        </AppBar>
    );
}

export default MenuList
